'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AppRoutes } from './AppRoutes.js';
import { AppContainer, AppExpandedContainer, FlexContainer, } from './components/AppContainer.js';
import { Expansion } from './components/Expansion/Expansion.js';
import { Header } from './components/Header/Header.js';
import { Initializer } from './components/Initializer.js';
import { version } from './config/version.js';
import { useWideVariant } from './hooks/useWideVariant.js';
import { useWidgetConfig } from './providers/WidgetProvider/WidgetProvider.js';
import { createElementId, ElementId } from './utils/elements.js';
export const AppDefault = () => {
    const { elementId } = useWidgetConfig();
    const wideVariant = useWideVariant();
    return (_jsxs(AppExpandedContainer, { id: createElementId(ElementId.AppExpandedContainer, elementId), "data-version": version, children: [_jsxs(AppContainer, { children: [_jsx(Header, {}), _jsx(FlexContainer, { disableGutters: true, children: _jsx(AppRoutes, {}) }), _jsx(Initializer, {})] }), wideVariant && _jsx(Expansion, {})] }));
};
//# sourceMappingURL=AppDefault.js.map